module.exports = __webpack_public_path__ + "img/d-loading.e8d78b94.gif";